<div class="technical-services-selector">
  <div
    class="technical-services-select-shell"
    [class.technical-services-select-shell--open]="technicalServicesSelectOpen"
  >
    <nz-select
      [ngModel]="selectedHeaderKeysInternal"
      (ngModelChange)="onSelectedHeaderKeysChange($event)"
      [nzOpen]="technicalServicesSelectOpen"
      (nzOpenChange)="onTechnicalServicesSelectOpenChange($event)"
      [nzMode]="'multiple'"
      [nzShowSearch]="true"
      [nzAllowClear]="true"
      [nzShowArrow]="true"
      [nzSuffixIcon]="serviceSelectCtaTpl"
      [nzDropdownMatchSelectWidth]="true"
      [nzPlaceHolder]="'PROPERTY_LIST.SELECT_SERVICE_TYPE' | translate"
      [nzMaxTagCount]="2"
      [nzMaxTagPlaceholder]="maxTagPlaceholderTpl"
      class="technical-services-select"
      [ngClass]="{
      'technical-services-select--empty': !selectedHeaderKeysInOrder.length,
      'technical-services-select--has-selection': selectedHeaderKeysInOrder.length > 0
      }"
    >
      <ng-container *ngFor="let group of optionGroups">
        <nz-option-group [nzLabel]="group.categoryTranslationKey | translate">
          <nz-option
            *ngFor="let service of group.options"
            [nzValue]="service.headerKey"
            [nzLabel]="'TECHNICAL_SERVICES.' + service.translationKey | translate"
          ></nz-option>
        </nz-option-group>
      </ng-container>
    </nz-select>
  </div>

  <ng-template #serviceSelectCtaTpl>
    <span
      class="technical-services-select-suffix-cta"
      role="button"
      tabindex="-1"
      (mousedown)="stopTechnicalServicesCtaEvent($event)"
      (click)="toggleTechnicalServicesSelect($event)"
    >
      <span class="technical-services-select-suffix-text">
        {{ 'PROPERTY_LIST.SELECT_DROPDOWN' | translate }}
      </span>
      <span nz-icon nzType="down" class="technical-services-select-suffix-icon"></span>
    </span>
  </ng-template>

  <div class="select-hint" *ngIf="!selectedHeaderKeysInOrder.length">
    {{ 'PROPERTY_LIST.TECH_SERVICES_HINT' | translate }}
  </div>
  <ng-template #maxTagPlaceholderTpl let-omittedValues>
  <span class="select-omitted-count">
    +{{ omittedValues?.length || 0 }} {{ 'PROPERTY_LIST.SELECTED_SHORT' | translate }}
  </span>
  </ng-template>
  <div class="error-message" *ngIf="showSelectionRequiredError">
    {{ 'PROPERTY_LIST.SERVICE_TYPE_REQUIRED' | translate }}
  </div>

  <div class="selected-services-row" *ngIf="selectedHeaderKeysInOrder.length">
    <nz-tag class="selected-service-chip" *ngFor="let headerKey of selectedHeaderKeysInOrder">
      {{ getServiceTranslationKey(headerKey) | translate }}
    </nz-tag>
  </div>

  <nz-collapse>
    <nz-collapse-panel
      [nzHeader]="'PROPERTY_LIST.TECHNICAL_SERVICES_ADVANCED_ORDERING' | translate"
      [nzActive]="false"
    >
      <div class="advanced-ordering-description">
        {{ 'PROPERTY_LIST.TECHNICAL_SERVICES_ADVANCED_ORDERING_HINT' | translate }}
      </div>
      <div class="advanced-ordering-description">
        {{ 'PROPERTY_LIST.TECHNICAL_SERVICES_CATEGORY_ORDER_HINT' | translate }}
      </div>
      <div class="emergency-placement-note" *ngIf="landingPageEmergencyServicePlacementEnabled">
        <strong>{{ 'PROPERTY_LIST.EMERGENCY_SERVICE_PLACEMENT_TITLE' | translate }}</strong>
        <span>{{ 'PROPERTY_LIST.EMERGENCY_SERVICE_PLACEMENT_HINT' | translate }}</span>
        <span>{{ 'PROPERTY_LIST.EMERGENCY_SERVICE_PLACEMENT_COMPANY_WIDE' | translate }}</span>
      </div>

      <div
        cdkDropList
        cdkDropListOrientation="horizontal"
        class="service-category-grid"
        [cdkDropListData]="categoryOrderInternal"
        (cdkDropListDropped)="onCategoryDrop($event)"
      >
        <div class="service-category-column" *ngFor="let categoryKey of categoryOrderInternal" cdkDrag>
          <div class="service-category-header">
            <span class="service-category-title">
              <span nz-icon nzType="drag" class="category-drag-handle" cdkDragHandle></span>
              {{ ('COMPANY_PAGE.TECHNICAL_SERVICE_CATEGORIES.' + categoryKey) | translate }}
            </span>
            <span class="service-category-count" *ngIf="(headerOrderInternal[categoryKey] || []).length">
              {{ (headerOrderInternal[categoryKey] || []).length }}
            </span>
          </div>

          <div
            cdkDropList
            class="service-type-list"
            [id]="getCategoryDropListId(categoryKey)"
            [cdkDropListData]="headerOrderInternal[categoryKey]"
            [cdkDropListConnectedTo]="connectedDropListIds"
            (cdkDropListDropped)="onDrop($event)"
          >
            <div
              class="service-type-item"
              *ngFor="let headerKey of headerOrderInternal[categoryKey]; let idx = index"
              cdkDrag
            >
              <span nz-icon nzType="menu" class="drag-handle" cdkDragHandle></span>
              <span class="service-type-index">{{ idx + 1 }}</span>
              <span
                class="service-type-label"
                [nz-tooltip]="getServiceTranslationKey(headerKey) | translate"
              >{{ getServiceTranslationKey(headerKey) | translate }}</span>
              <button
                *ngIf="landingPageEmergencyServicePlacementEnabled"
                type="button"
                nz-button
                nzSize="small"
                class="emergency-placement-toggle"
                [class.emergency-placement-toggle--active]="isEmergencyPlacementActive(headerKey)"
                [attr.aria-pressed]="isEmergencyPlacementActive(headerKey)"
                [attr.aria-label]="'PROPERTY_LIST.EMERGENCY_SERVICE_PLACEMENT_TOOLTIP' | translate"
                [nz-tooltip]="'PROPERTY_LIST.EMERGENCY_SERVICE_PLACEMENT_TOOLTIP' | translate"
                (mousedown)="$event.stopPropagation()"
                (pointerdown)="$event.stopPropagation()"
                (click)="toggleEmergencyPlacement(headerKey, $event)"
              >
                <span
                  nz-icon
                  [nzType]="isEmergencyPlacementActive(headerKey) ? 'check' : 'alert'"
                ></span>
                {{ 'PROPERTY_LIST.EMERGENCY_SERVICE_PLACEMENT_BUTTON' | translate }}
              </button>
            </div>

            <div class="service-type-empty" *ngIf="!(headerOrderInternal[categoryKey]?.length)">
              {{ 'COMPANY_PAGE.TECHNICAL_SERVICE_CATEGORY_EMPTY' | translate }}
            </div>
          </div>
        </div>
      </div>
    </nz-collapse-panel>
  </nz-collapse>
</div>
